import FetchClient from "@dpdgroupuk/fetch-client";
import { EnvUtil } from "../utils";
import { isWrongUrlError } from "../features/Auth/AuthErrors";

class AbstractApisClient extends FetchClient {
  constructor({
    fallbackBaseUrl,
    baseUrl,
    ...options
  }) {
    super({
      mode: "cors",
      credentials: "include",
      baseUrl: baseUrl || EnvUtil.getApisOrigin(window.location, fallbackBaseUrl),

      onRetryError(retry, err) {
        if (err.statusCode === 401 && !isWrongUrlError(err)) {
          if (this.isRefreshing && this.refreshingToken) {
            return this.refreshingToken.then(() => {
              return retry();
            });
          }

          this.isRefreshing = true;
          this.refreshingToken = this.get({
            path: `/auth/refreshToken`,
            options: { ...options,
              onRetryError: null
            }
          }).finally(() => {
            this.refreshingToken = null;
            this.isRefreshing = false;
          }).then(() => {
            return retry();
          });
          return this.refreshingToken;
        }

        throw err;
      },

      ...options
    });
  }

  getApisBaseUrl() {
    return this.options.baseUrl;
  }

}

export default AbstractApisClient;